<ngx-main-layout class="main-layout">
  <nb-menu autoCollapse="true" tag="filterMenu" [items]="filteredMenu" (click)="onItemClick()"></nb-menu>
  <nb-menu autoCollapse="true" tag="rightMenu" [items]="rightMenu"></nb-menu>
  <router-outlet></router-outlet>
</ngx-main-layout>
